<template>
    <div>
        <MainModal 
            :show-modal="showModal" 
            size="sm" 
            title="Upgrade account" 
            @close="$emit('cancel')"
        >
            <template #body>
                <div class="modal__wrapper--onboarding">
                    <slot v-if="customText" name="text" />
                    <div v-else class="modal--section">
                        <div>
                            <p class="text--sm text-gray-400">
                                You have exceeded the allowed number of {{ computeType() }} for your account plan. 
                            </p>
                            <p class="text--sm text-gray-400 mt--15">
                                To create more {{ computeType() }}, go to your app <strong>Settings > Payments and Billngs</strong> and upgrade your account plan.
                            </p>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="w-100 flex justify-content-end align-items-center">
                    <BaseButton 
                        label="Cancel" 
                        variant="outline" 
                        @submit="$emit('cancel', false)"
                    />
                    <BaseButton 
                        label="Go to settings" 
                        class="ml--5" 
                        @submit="upgradeAccount"
                    />
                </div>
            </template>
        </MainModal>
    </div>
</template>

<script>
import { camelCaseToSpaced } from "@/utils/strings";
import BaseButton from "../buttons/BaseButton.vue";
import MainModal from "./MainModal.vue";

export default {
    name: "UpgradeAccount",

    components: { MainModal, BaseButton },

    props: {
        type: {
            type: String,
            default: "",
        },
        showModal: {
            type: Boolean,
            default: false,
        },
        customText: {
            type: Boolean,
            default: false,
        },
    },

    emits: ["cancel"],

    methods: {
        upgradeAccount() {
            this.$emit("cancel");
            this.$router.push("/dashboard/settings/payments-and-billings");
        },

        computeType() {
            if (!this.type) return "";

            return camelCaseToSpaced(this.type);
        },
    },
};
</script>